import { useFm, useParams } from '@web3/base-hooks';

export const CheckAssetsListButton = () => {
  const fm = useFm();
  const { locale } = useParams();

  const handleClick = () => {
    window.open(
      `${window.location.origin}/${locale}/help-center/article/FAQ-Web3-Points`,
      '_blank'
    );
  };

  return (
    <span
      className="medium-12 text-[#9747FF] cursor-pointer"
      onClick={handleClick}
    >
      {fm('checkAssetsList')}
    </span>
  );
};
